import React, { useRef, useState } from 'react';
import { useGroupsStore } from '../../../../../../../store/groups/Groups';
import { useOwnerStore } from '../../../../../../../store/owner/useOwnerStore';
import { usePTTGroupsStore } from '../../../../../../../store/pttGroups/usePTTGroupsStore';
import { useOperator } from '../../../../../../../store/users/Operators';
import { useFilesStore } from '../../../../../../../store/devices/FilesDevicesFromDB';
import { File } from '../../../../../../../types/File';
import { Moment } from 'moment';
import { useAuthStore } from '../../../../../../../store/auth/auth';
import { FormFileFiltrationValues } from '../../components/ArchiveFilters/consts/consts';
import usePTTMessageStore, {
    PTTMessage,
} from '../../../../../pttDispatcher/api/usePttMessageStore';
import { useDevicesStore } from '../../../../../../../store/devices/allDevices';
import { DeviceByGroupStore } from '../../../../../../../store/devices/DeviceByGroupStore';
import { useUserStore } from '../../../../../../../store/users/UserStore';

import { FormInstance } from 'antd';

export const useArchiveSearch = () => {
    const [contentType, setContentType] = useState<'files' | 'radiochat'>('files');
    const [messageType, setMessageType] = useState(1);
    const [authorType, setAuthorType] = useState(1);
    const [recipientType, setRecipientType] = useState(2);
    const [fileType, setFileType] = useState<number | undefined>(0);
    const [selectedFiles, setSelectedFiles] = useState<Record<string, boolean>>({});
    const [isSearching, setIsSearching] = useState(false);
    const { user, SmartDVRToken } = useAuthStore();
    const [isInitialized, setIsInitialized] = useState(false);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 50,
        total: 0,
    });

    // Store hooks
    const { groups, fetchGroups } = useGroupsStore();
    const { owners, fetchOwners } = useOwnerStore();
    const { groups: pttGroups, fetchGroups: fetchPttGroups } = usePTTGroupsStore();
    const { users: operators, fetchUsers: fetchOperators } = useOperator();
    const { fetchFiles, filesArchive, resetArchiveFiles } = useFilesStore();
    const { fetchMessages, clearArchiveMessages } = usePTTMessageStore();
    const { fetchDevicesByStore, allDevices, fetchAllDevices } = DeviceByGroupStore();
    const { users, fetchUsers } = useUserStore();

    const fetchInitialData = async () => {
        await Promise.all([
            fetchGroups(),
            fetchOwners(1, 100),
            fetchPttGroups(),
            fetchOperators(),
            fetchAllDevices(SmartDVRToken, user?.login!),
            fetchUsers(),
        ]);
        await onReset();
    };

    const formatDateForAPI = (date: Moment | null): string | undefined => {
        if (!date) return undefined;
        return date.format('YYYY-MM-DDTHH:mm:ss[Z]');
    };

    const handleFileClick = (file: File | PTTMessage) => {
        console.log('Selected file:', file);
    };

    const handleCheckboxChange = (fileId: string, checked: boolean) => {
        setSelectedFiles((prev) => ({ ...prev, [fileId]: checked }));
    };

    const getFileTypeToBack = (fileType: number | undefined): 'm4a' | 'jpg' | 'mpd' | undefined => {
        switch (fileType) {
            case 0:
                return undefined;
            case 1:
                return 'mpd';
            case 2:
                return 'jpg';
            case 3:
                return 'm4a';
            default:
                return undefined;
        }
    };

    const buildRadiochatParams = (values: any) => {
        console.log(values);
        const baseParams = {
            start: formatDateForAPI(values.fromDate) || '2025-01-01T00:00:00Z',
            end: formatDateForAPI(values.toDate) || '2099-01-01T00:00:00Z',
            // page: pagination.current,
            // count: pagination.pageSize,
            groupUID: values.audioRoom || undefined,
            operatorUID: values.operatorAuthor || undefined,
            deviceUID: values.devicePttAuthor || undefined,
        };

        return baseParams;
    };

    const getSearchTypeDescription = (values: any): string => {
        const hasGroup = !!values.audioRoom;
        const hasOperator = !!values.operatorAuthor;
        const hasDevice = !!values.devicePttAuthor;

        if (hasGroup && hasOperator && hasDevice) {
            return 'Переписка в группе между оператором и устройством';
        } else if (hasGroup && hasOperator) {
            return 'Все сообщения с оператором в группе';
        } else if (hasGroup && hasDevice) {
            return 'Все сообщения с устройством в группе';
        } else if (hasOperator && hasDevice) {
            return 'Личные сообщения между оператором и устройством';
        } else if (hasGroup) {
            return 'Все сообщения в группе';
        } else if (hasOperator) {
            return 'Все сообщения с оператором';
        } else if (hasDevice) {
            return 'Все сообщения с устройством';
        } else {
            return 'Все сообщения (без фильтров)';
        }
    };

    const onSearch = async (values: any, page: number = 1, pageSize: number = 50) => {
        setIsSearching(true);

        console.log(values);
        try {
            const params = {
                deviceUID: values.device ?? undefined,
                start: formatDateForAPI(values.fromDate) || undefined,
                end: formatDateForAPI(values.toDate) || undefined,
                callsign: values.callsign || undefined,
                serialNumber: values.serialNumber || undefined,
                groupUID: values.group ?? undefined,
                city: values.city?.join(',') || undefined,
                street: values.street?.join(',') || undefined,
                fileType: getFileTypeToBack(fileType) || undefined,
                creator: values.creator,
                rating: values.ratings?.length > 0 ? values.ratings : undefined,
                messageType: contentType === 'radiochat' ? messageType : undefined,
                authorType: contentType === 'radiochat' ? authorType : undefined,
                caseNumber: Number(values.caseNumber) ?? undefined,
                page,
                count: pageSize,
            };

            // Реальный запрос к API
            if (contentType === 'files') {
                const response = await fetchFiles(
                    params,
                    SmartDVRToken!,
                    user?.login!,
                    page,
                    pageSize,
                    true,
                );
                console.log(response);
                setPagination((prev) => ({
                    ...prev,
                    current: page,
                    pageSize,
                    // @ts-ignore
                    total: response?.len || 0,
                }));
            } else {
                if (!pttGroups || pttGroups.length === 0) {
                    await fetchPttGroups();
                }

                const radiochatParams = buildRadiochatParams(values);
                console.log(radiochatParams);
                // const radiochatParams = {
                //     // Базовые параметры
                //     start: params.start ?? '2025-01-01T00:00:00Z',
                //     end: params.end ?? '2099-01-01T00:00:00Z',
                //
                //     // Параметры для типа сообщения
                //     ...(messageType === 1 ? {
                //         // Личные сообщения
                //         recipient_type: 'operator', // или 'device' в зависимости от выбора
                //         receiver_type: 'operator',  // или 'device' в зависимости от выбора
                //         recipient_uid: values.operatorRecipient || values.devicePttRecipient || undefined,
                //         receiver_uid: values.operatorAuthor || values.devicePttAuthor || undefined,
                //     } : {
                //         // Сообщения в группу
                //         recipient_type: 'group',
                //         receiver_type: 'group',
                //         recipient_uid: values.audioRoom || undefined,
                //         receiver_uid: values.audioRoom || undefined,
                //     }),
                //
                //     // Дополнительные параметры отправителя/получателя
                //     ...(values.operatorAuthor && {
                //         sender_operator_uid: values.operatorAuthor
                //     }),
                //     ...(values.devicePttAuthor && {
                //         sender_device_uid: values.devicePttAuthor
                //     }),
                //     ...(values.operatorRecipient && {
                //         recipient_operator_uid: values.operatorRecipient
                //     }),
                //     ...(values.devicePttRecipient && {
                //         recipient_device_uid: values.devicePttRecipient
                //     }),
                //
                //     page,
                //     count: pageSize,
                // };
                //
                const response = await fetchMessages(
                    {
                        data: radiochatParams,
                        SmartDVRToken: SmartDVRToken!,
                        userLogin: user?.login!,
                        devices: allDevices,
                        pttGroups: pttGroups,
                        operators,
                        users,
                        page,
                        count: pageSize,
                    },
                    true,
                );

                // const response = await fetchMessages(
                //     {
                //         data: {
                //             // deviceUID: params.deviceUID ?? '',
                //             // groupUID: params.groupUID ?? '',
                //             // recipient_type: messageType == 1 ? undefined : 'group',
                //             // receiver_type: messageType == 1 ? undefined : 'group',
                //             groupUID: values.audioRoom ?? undefined,
                //             // recipient_uid: values.devicePtt || values.operator || undefined,
                //             // receiver_uid: values.devicePtt || values.operator || undefined,
                //             end: params.end ?? '2099-01-01T00:00:00Z',
                //             start: params.start ?? '2025-01-01T00:00:00Z',
                //         },
                //         SmartDVRToken: SmartDVRToken!,
                //         userLogin: user?.login!,
                //         devices: allDevices,
                //         pttGroups: pttGroups,
                //         operators,
                //         users,
                //         page,
                //         count: pageSize,
                //         // Другие необходимые параметры
                //     },
                //     true,
                // );
                console.log(response);

                setPagination((prev) => ({
                    ...prev,
                    current: page,
                    pageSize,
                    total: response[1].data.len || 0,
                }));
            }
        } catch (error) {
            console.error('Ошибка при поиске:', error);
        } finally {
            setIsSearching(false);
        }
    };

    const createHandlePageChange =
        (form: FormInstance) => async (page: number, pageSize: number) => {
            try {
                const values = await form.validateFields();
                await onSearch(values, page, pageSize);
            } catch (error) {
                console.error('Ошибка валидации:', error);
            }
        };

    const onReset = async () => {
        setSelectedFiles({});
        setContentType(contentType);
        setMessageType(1);
        setAuthorType(1);
        setRecipientType(1);
        setFileType(0);
        setPagination((prev) => ({
            ...prev,
            current: 1,
            pageSize: 50,
            total: 0,
        }));
        // Сброс фильтров и очистка файлов
        try {
            resetArchiveFiles();
            // await fetchFiles(
            //     { start: '2025-01-01T00:00:00Z', end: '2099-01-01T00:00:00Z' }, // или device?.UID если нужно для конкретного устройства
            //     SmartDVRToken!,
            //     user?.login!,
            //     1,
            //     1000,
            //     true,
            // );
            // await fetchMessages(
            //     {
            //         data: {
            //             end: '2099-01-01T00:00:00Z',
            //             start: '2025-01-01T00:00:00Z',
            //         },
            //         SmartDVRToken: SmartDVRToken!,
            //         userLogin: user?.login!,
            //         devices: allDevices,
            //         pttGroups: pttGroups,
            //         operators,
            //         users,
            //         // Другие необходимые параметры
            //     },
            //     true,
            // );
            clearArchiveMessages();
        } catch (error) {
            console.error('Ошибка при сбросе фильтров:', error);
        }
    };
    return {
        // State
        contentType,
        messageType,
        authorType,
        recipientType,
        fileType,
        selectedFiles,
        isSearching,
        groups,
        owners,
        pttGroups,
        operators,
        isInitialized,
        allDevices,
        users,
        pagination,
        // Handlers
        createHandlePageChange,
        setContentType,
        setMessageType,
        setAuthorType,
        setRecipientType,
        setFileType,
        handleFileClick,
        handleCheckboxChange,
        onSearch,
        onReset,
        fetchInitialData,
        setPagination,
    };
};
